import React from 'react';
import { IBackgroundProps } from './types';

export enum EStickerVariants {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
}
interface IStickerProps extends IBackgroundProps {
  variant?: keyof typeof EStickerVariants;
}

const StickerBackground: React.FC<IStickerProps> = ({
  width,
  height,
  color,
  variant,
  UNSAFE_className,
  ...props
}) => {
  const svgProps = {
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    ...props,
  };

  switch (variant) {
    case EStickerVariants.A:
      return (
        <svg
          width={width || 326}
          height={height || 226}
          viewBox="0 0 326 226"
          className={UNSAFE_className || ''}
          {...svgProps}
        >
          <path
            fill={color || '#FFF'}
            d="M17.5325 183.327C31.1098 202.022 49.7487 220.756 118.208 225.293C186.667 229.83 291.369 226.428 307.478 201.474C323.586 176.521 342.475 46.4993 297.41 17.7288C267.207 -1.55319 176.6 -2.68742 118.208 2.98374C59.8162 8.6549 28.0361 16.025 13.5055 44.9503C-7.65584 87.0753 -0.589019 158.374 17.5325 183.327Z"
          />
        </svg>
      );
    case EStickerVariants.B:
      return (
        <svg
          width={width || 301}
          height={height || 251}
          viewBox="0 0 301 251"
          className={UNSAFE_className || ''}
          {...svgProps}
        >
          <path
            fill={color || '#FFF'}
            d="M16.2223 201.955C28.7552 222.55 45.9603 243.187 109.153 248.185C172.347 253.183 268.995 249.435 283.864 221.946C298.733 194.458 316.169 51.2241 274.571 19.5302C246.691 -1.71101 163.053 -2.96049 109.153 3.28692C55.2534 9.53432 25.9179 17.6533 12.5051 49.5177C-7.02846 95.923 -0.505248 174.466 16.2223 201.955Z"
          />
        </svg>
      );
    case EStickerVariants.D:
      return (
        <svg
          width={width || 282}
          height={height || 181}
          viewBox="0 0 282 181"
          className={UNSAFE_className || ''}
          {...svgProps}
        >
          <path
            d="M54.2549 9.70403C31.0295 17.2559 7.7564 27.6231 2.12021 65.7011C-3.51598 103.779 0.711161 162.016 31.7102 170.976C62.7092 179.935 224.234 190.442 259.976 165.376C283.93 148.577 285.339 98.1794 278.293 65.7011C271.248 33.2228 278.293 19.7835 226.159 7.46413C174.024 -4.85523 85.254 -0.375454 54.2549 9.70403Z"
            fill={color || '#FFCB03'}
          />
        </svg>
      );
    case EStickerVariants.E:
      return (
        <svg
          width={width || 422}
          height={height || 153}
          viewBox="0 0 422 153"
          className={UNSAFE_className || ''}
          {...svgProps}
        >
          <path
            fill={color || '#FFF'}
            d="M10.7439 133.325C-7.86591 85.5599 -1.62291 30.0726 24.2342 7.80838C26.7014 5.72639 29.761 4.03925 33.2118 2.85794C36.6625 1.67664 40.4262 1.02794 44.2551 0.954559C144.449 -1.62604 323.094 1.02573 392.693 8.90985C397.69 9.44991 402.382 10.9583 406.251 13.2694C410.12 15.5805 413.018 18.6048 414.626 22.01C430.883 57.3732 417.021 111.165 404.124 134.302C402.275 137.616 399.189 140.509 395.198 142.67C391.207 144.831 386.463 146.177 381.476 146.564C308.725 152.271 121.576 157.099 33.3708 147.67C28.0507 147.091 23.0814 145.427 19.0652 142.881C15.0491 140.335 12.1585 137.015 10.7439 133.325Z"
          />
        </svg>
      );
    case EStickerVariants.F:
      return (
        <svg
          width={width || 327}
          height={height || 153}
          viewBox="0 0 327 153"
          className={UNSAFE_className || ''}
          {...svgProps}
        >
          <path
            fill={color || '#FFF'}
            d="M8.32529 133.325C-6.09515 85.5599 -1.25757 30.0726 18.7786 7.80838C20.6904 5.72639 23.0613 4.03925 25.7352 2.85794C28.4091 1.67664 31.3255 1.02794 34.2925 0.954559C111.931 -1.62604 250.359 1.02573 304.291 8.90985C308.163 9.44991 311.798 10.9583 314.796 13.2694C317.795 15.5805 320.04 18.6048 321.286 22.01C333.883 57.3732 323.142 111.165 313.148 134.302C311.715 137.616 309.324 140.509 306.232 142.67C303.139 144.831 299.463 146.177 295.599 146.564C239.225 152.271 94.2072 157.099 25.8584 147.67C21.736 147.091 17.8854 145.427 14.7733 142.881C11.6613 140.335 9.42142 137.015 8.32529 133.325Z"
          />
        </svg>
      );

    case EStickerVariants.C:
    default:
      return (
        <svg
          width={width || 176}
          height={height || 119}
          viewBox="0 0 176 119"
          className={UNSAFE_className || ''}
          {...svgProps}
        >
          <path
            fill={color || '#FFBDA7'}
            d="M6.54848 12.458C-4.46739 50.5938 0.955812 86.656 11.6874 106.49C12.9143 108.769 14.8466 110.744 17.2913 112.216C19.7359 113.689 22.6074 114.608 25.6187 114.881C83.2156 120.087 133.171 119.117 155.787 115.494C159.069 114.973 162.095 113.675 164.496 111.761C166.896 109.847 168.567 107.399 169.304 104.716C176.895 77.5682 177.518 49.4157 171.133 22.0585C170.503 19.3299 168.909 16.8147 166.552 14.8272C164.194 12.8398 161.176 11.4683 157.876 10.8841C101.473 0.838461 48.8518 -1.34336 20.8767 1.88631C17.4738 2.25919 14.2865 3.46736 11.7305 5.35319C9.17455 7.23903 7.36868 9.71498 6.54848 12.458Z"
          />
        </svg>
      );
  }
};

export default StickerBackground;
